// src/components/simulator/engines/StockInvestmentEngine.js

export const simulateStockInvestment = (params) => {
  const { propertyValue, stockGrowthRate, termYears } = params;

  const yearlyData = [];
  let stockValue = propertyValue;

  for (let year = 1; year <= termYears; year++) {
    stockValue *= (1 + stockGrowthRate / 100);

    yearlyData.push({
      year,
      stockValue: Math.round(stockValue),
    });
  }

  const finalYear = yearlyData[yearlyData.length - 1];

  const investorResult = {
    model: 'Stock Investment',
    finalValue: Math.round(finalYear.stockValue),
    assetAppreciation: Math.round(finalYear.stockValue - propertyValue),
    totalROI: (((finalYear.stockValue - propertyValue) / propertyValue) * 100).toFixed(1),
    annualizedROI: ((Math.pow(1 + ((finalYear.stockValue - propertyValue) / propertyValue), 1 / termYears) - 1) * 100).toFixed(1),
    originalPropertyValue: Math.round(propertyValue),
    netCashflow: 0,
    cashOnCashReturn: 0,
    irrEstimate: ((Math.pow(1 + ((finalYear.stockValue - propertyValue) / propertyValue), 1 / termYears) - 1) * 100).toFixed(1),
    exitValue: Math.round(finalYear.stockValue),
    finalNetProfit: Math.round(finalYear.stockValue - propertyValue),
    termYears,
  };

  return {
    investorResult,
    borrowerResult: null,
    yearlyData,
  };
};
